import { SolNavbar, SolNavbarItem } from '@sol/components';
import { SolIcon } from '@sol/icons';
import { PrototypeRouteId } from '../../models/prototype-route-id';

export const vulnerabilityCatalogNavbar: SolNavbar = {
  menu: [
    SolNavbarItem.of(PrototypeRouteId.app_vulnerability_catalog, {
      displayName: 'Vulnerability catalog',
      icon: SolIcon.vulnerability,
      showChildrenAsTabs: true,
      children: [
        SolNavbarItem.of(PrototypeRouteId.vulnerability_catalog_dashboard, {
          displayName: 'Overview',
        }),
        SolNavbarItem.of(PrototypeRouteId.vulnerability_catalog_list, {
          displayName: 'Catalog',
          children: [
            SolNavbarItem.of(PrototypeRouteId.vulnerability_catalog_detail, {
              displayName: 'asm-prototype.vulnerability-catalog.cve.name',
              nameParams: ['cveId'],
            }),
          ],
        }),
      ],
    }),
  ],
  system: [],
  account: [
    SolNavbarItem.of(PrototypeRouteId.account_section1, {
      children: [
        SolNavbarItem.of(PrototypeRouteId.account_preferences, {
          displayName: 'Preferences',
        }),
      ],
    }),
    SolNavbarItem.of(PrototypeRouteId.account_section2, {
      children: [SolNavbarItem.of(PrototypeRouteId.account_logout, { displayName: 'Logout' })],
    }),
  ],
};
